import { memo } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useTrackTimeSpent } from './hooks/use-time-spent';
import { BookingPage } from './pages/Booking';
import { MainPage } from './pages/Main';
import { ReportPage } from './pages/Report';
import { RedirectPage } from './pages/Redirect';

const App = memo(() => {
  useTrackTimeSpent();

  return (
    <Routes>
      <Route path='/redirect/:id' element={<RedirectPage />} />
      <Route path='/book-a-demo' element={<BookingPage />} />
      <Route
        path='/report/full'
        element={<ReportPage key='report-full' requireEmailGate={false} />}
      />
      <Route path='/report' element={<ReportPage key='report-gated' />} />
      <Route path='/' element={<MainPage />} />
      <Route path='*' element={<Navigate to='/' replace />} />
    </Routes>
  );
});

export default App;

